import React, { useContext } from "react";
import { toast } from "react-toastify";
import { ToastNotification } from "../../../../core/ToastNotification";

export const ArticleShareButton = (props) => {
    const onClick = () => {
        navigator.clipboard.writeText(props.data).then(
            () => {
                //Alerts.showInfo("Url has been copied to clipboard", "Url");
                //alerts.addMessage("Url has been copied to the clipboard.");
                toast.info(ToastNotification, {
                    customProgressBar: true,
                    data: { content: "Url has been copied to the clipboard." },
                });
            },
            (err) => {
                console.error(err);
            }
        );
    };

    return (
        <div className="btn-round fixed-left background-blue" onClick={onClick}>
            <span className="glyphicon glyphicon-share"></span>
        </div>
    );
};
